// src/lib/usefetchNotifications.js
import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const fetchNotifications = async ({ pageParam = 1, queryKey }) => {
  const [, { token, user, limit }] = queryKey;
  const role = user?.role;

  if (!role) {
    throw new Error('User role is undefined');
  }

  const url = `${process.env.REACT_APP_SERVER_URL}/notification/${role}?page=${pageParam}&limit=${limit}`;
  console.log('Fetching notifications with URL:', url);

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    console.error('Fetch error:', response.status, response.statusText);
    throw new Error(`Network response was not ok (${response.status})`);
  }

  const data = await response.json();
  console.log('Fetched notifications:', data);
  return data; // Expected format: {status: 'Success', data: Array(1)}
};

export const useNotifications = (limit = 10) => {
  const { token, user } = useContext(AuthContext);

  return useInfiniteQuery(
    ['notifications', { token, user, limit }],
    fetchNotifications,
    {
      getNextPageParam: (lastPage, pages) => {
        // If the number of notifications fetched is less than the limit, assume no more pages
        if (lastPage.data.length < limit) {
          return undefined; // No more pages
        }
        return pages.length + 1; // Next page number
      },
      enabled: !!token && !!user && !!user.role, // Ensure token, user, and role are present
      keepPreviousData: true,
    }
  );
};
